module.exports = __webpack_public_path__ + "img/icon_sportMenu_baseball.ea8933f1.svg";